import axios from 'axios'

let baseURL = 'https://api-pre.chinabeego.com/';
let env = window.localStorage.getItem('env') || 'test';
baseURL = env == 'test' && 'https://api-test.chinabeego.com/' || baseURL;
baseURL = env == 'testb' && 'https://api-testb.chinabeego.com/' || baseURL;
baseURL = env == 'testc' && 'https://api-testc.chinabeego.com/' || baseURL;
baseURL = env == 'testd' && 'https://api-testd.chinabeego.com/' || baseURL;
baseURL = env == 'pre' && 'https://api-pre.chinabeego.com/' || baseURL;
baseURL = env == 'idc' && 'https://api.chinabeego.com/' || baseURL;
if (process.env.NODE_ENV == 'production') {
  baseURL = process.env.VUE_APP_BASEURL
}


export default function gioFun(_obj){
  return new Promise((resolve,reject)=>{
    let url = baseURL+'/order/app/item/send_goods_detail'
    axios.post(url,_obj).then(rps=>{
      resolve(rps)
    }).catch(err=>{
      reject(err)
    })
  })
}